export const TROVIT_NEWSLETTERS = 'trovitNewsletters';
export const PARTNERS_NEWSLETTERS = 'partnersNewsletters';

export const TROVIT_NEWSLETTERS_TYPE = '1';
export const PARTNERS_NEWSLETTERS_TYPE = '2';



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/NewsletterNotifications/constants.js